import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import SystemSetting from '../../components/SystemSetting';
import { isRoot } from '../../helpers';
import OtherSetting from '../../components/OtherSetting';
import PersonalSetting from '../../components/PersonalSetting';
import OperationSetting from '../../components/OperationSetting';
import AutoUpdateSetting from '../../components/AutoUpdateSetting';
import ChannelProxySetting from '../../components/ChannelProxySetting';
import { StudioHero, StudioPage } from '../../components/StudioPage';
import './Settings.css';

const Setting = () => {
  const { t } = useTranslation();

  let panes = [
    {
      menuItem: t('setting.tabs.personal'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <PersonalSetting />
        </Tab.Pane>
      ),
    },
  ];

  if (isRoot()) {
    panes.push({
      menuItem: t('setting.tabs.operation'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <OperationSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.system'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <SystemSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.other'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <OtherSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.proxy_subscription'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <ChannelProxySetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.autoupdate'),
      render: () => (
        <Tab.Pane attached={false} className='settings-tab-pane'>
          <AutoUpdateSetting />
        </Tab.Pane>
      ),
    });
  }

  return (
    <StudioPage className='studio-settings-page'>
      <StudioHero
        icon='setting'
        kicker='AI STUDIO / SETTINGS'
        title={t('setting.title')}
        description={t('setting.studio_subtitle')}
      />
      <div className='settings-workspace studio-surface'>
        <Tab
          className='studio-tabs studio-settings-content'
          menu={{
            secondary: true,
            pointing: true,
            className: 'settings-tab',
          }}
          panes={panes}
        />
      </div>
    </StudioPage>
  );
};

export default Setting;
